import { render } from "./UserAssetsView.vue?vue&type=template&id=26802898&scoped=true&ts=true"
import script from "./UserAssetsView.vue?vue&type=script&lang=ts"
export * from "./UserAssetsView.vue?vue&type=script&lang=ts"

import "./UserAssetsView.vue?vue&type=style&index=0&id=26802898&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26802898"]])

export default __exports__